import { getFirstVisibleElementOfClass } from '../../lib/utils/helpers';

export default {
	methods: {
		isNumberChecker(numberStringValue) {
			const integerValue = parseInt(numberStringValue)
			if (Number.isInteger(integerValue)) {
				return integerValue
			} else {
				return 0
			}
		},
		scrollToVisibleResults() {
			const resultsContainer = getFirstVisibleElementOfClass('.results-container');
			if (!resultsContainer) return;

			setTimeout(() => {
				resultsContainer.scrollIntoView({ behavior: 'smooth' });
			}, 150);
		}
	}
}
